<template>
  <div class="base-header">
    <div class="nav2">
      <ul>
        <li
          v-for="(item, index) in menu"
          :key="index"
          :class="{
            active: $route.name == item.path,
          }"
          @click="goMenu(item.id, item.path)"
        >
          <i :class="[item.icon]"></i>
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "base-header",
  data() {
    return {
      menu: [
        {
          id: 1,
          img1: require("@/assets/img/nav2/b1.png"),
          img2: require("@/assets/img/nav2/b11.png"),
          icon: "iconfont icon-shouye ",
          selState: true,
          path: "Index",
          child: ["Index", "Openbox"],
          value: "CASES",
        },
        {
          id: 2,
          img1: require("@/assets/img/nav2/b2.png"),
          img2: require("@/assets/img/nav2/b22.png"),
          icon: "iconfont icon-icon_duizhan ",
          selState: false,
          path: "Lucky",
          child: ["Lucky", "LuckyRoom", "LuckyRule", "LuckyHistory"],
          value: "BATTLES",
        },
        {
          id: 3,
          img1: require("@/assets/img/nav2/b3.png"),
          img2: require("@/assets/img/nav2/b33.png"),
          selState: false,
          icon: "hxd-iconfont hxd-roll",
          path: "Arena",
          child: ["Arena", "ArenaRoom"],
          value: "ROLL",
        },
        {
          id: 4,
          img1: require("@/assets/img/nav2/b4.png"),
          img2: require("@/assets/img/nav2/b44.png"),
          icon: "iconfont icon-lucky_right",
          selState: false,
          path: "Ornament",
          child: [
            "Ornament",
            "OrnamentOpen",
            "OrnamentHistory",
            "OrnamentHistory2",
          ],
          value: "UPGRADE",
        },
        {
          id: 5,
          img1: require("@/assets/img/nav2/b5.png"),
          img2: require("@/assets/img/nav2/b55.png"),
          selState: false,
          icon: "hxd-iconfont hxd-shangcheng",
          path: "Roll",
          child: ["Roll"],
          value: "STORE",
        },
        {
          id: 6,
          img1: require("@/assets/img/nav2/b6.png"),
          img2: require("@/assets/img/nav2/b66.png"),
          selState: false,
          icon: "hxd-iconfont hxd-mianfeijinbi",
          path: "Spread",
          child: ["Spread"],
          value: "PARTNER",
        },
        {
          id: 7,
          img1: require("@/assets/img/nav2/b8.png"),
          img2: require("@/assets/img/nav2/b88.png"),
          selState: false,
          icon: "iconfont icon-beibao",
          path: "Dota",
          child: ["Dota"],
          value: "INVENTORY",
        },
      ],
    };
  },
  methods: {
    goMenu(id, path) {
      this.$emit("goMenu", id, path);
    },
  },
};
</script>

<style lang="less" scoped>
i {
  margin-right: 5px;
}
.icon-beibao {
  font-size: 20px;
}
.hxd-mianfeijinbi {
  font-size: 26px;
}
.icon-lucky_right {
  font-size: 18px;
}
.hxd-shangcheng {
  font-size: 21px;
}
.icon-shouye {
  font-size: 20px;
}
.icon-icon_duizhan {
  font-size: 30px;
}
.hxd-roll{
  font-size: 23px;
}
.icon-icon_duizhan{
  font-size: 26px;
}
.icon-shouye{
  font-size: 18px;
}

.base-header {
  padding-left: 34px;
  .nav2 {
    height: 42px;
    ul {
      display: flex;
      height: 100%;
      align-items: center;
      .active {
        color: #edb145;
        background: rgba(237, 177, 69, 0.12);
        border-color: rgba(237, 177, 69, 0.36);
      }
      li {
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 34px;
        padding: 0 12px;
        text-align: center;
        cursor: pointer;
        color: #a7b3c5;
        font-size: 12px;
        line-height: 34px;
        margin-left: 10px;
        white-space: nowrap;
        font-weight: 900;
        border: 1px solid transparent;
        border-radius: 8px;
        transition: all 160ms ease;
        &:hover {
          color: #ffffff;
          background: rgba(255, 255, 255, 0.06);
        }
      }
    }
  }
}
</style>
